import { Textarea } from '@chakra-ui/react';

const VTextarea = ({ ...props }) => <Textarea {...props} />;

export default VTextarea;
